import { render } from "./MountpointDisplayRich.vue?vue&type=template&id=c5736722"
import script from "./MountpointDisplayRich.vue?vue&type=script&lang=js"
export * from "./MountpointDisplayRich.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__